import React from 'react'
import styles from '../EdofCrative/EdofCrative.module.css'

const EdofCrative = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.smartImage}>
                    <img src='Images/Smart-Object.webp' alt='illustration comparing vision clarity: far and near views blurred versus afocal EDOF lens providing continuous sharpness' loading="lazy" decoding="async" />
                </div>
              

            </div>
        </div>
    )
}

export default EdofCrative
